<script>
export default {
  name: "IconInvite"
};
</script>

<template>
  <svg width="16" height="17" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#icon-invite-mask)" fill="currentcolor">
      <path
        d="M3.833 4.833a2 2 0 0 1 2-2 .667.667 0 1 0 0-1.333 3.333 3.333 0 1 0 0 6.667.667.667 0 1 0 0-1.334 2 2 0 0 1-2-2Z"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M2.25 4.833A3.583 3.583 0 0 1 5.833 1.25a.917.917 0 1 1 0 1.833 1.75 1.75 0 0 0 0 3.5.917.917 0 1 1 0 1.834A3.583 3.583 0 0 1 2.25 4.833ZM5.833 1.75a3.083 3.083 0 1 0 0 6.167.417.417 0 1 0 0-.834 2.25 2.25 0 0 1 0-4.5.417.417 0 1 0 0-.833ZM10.667 1.5a3.333 3.333 0 1 0 0 6.667 3.333 3.333 0 0 0 0-6.667Zm-2 3.333a2 2 0 1 1 4 0 2 2 0 0 1-4 0Z"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M7.083 4.833a3.583 3.583 0 1 1 7.167 0 3.583 3.583 0 0 1-7.167 0Zm3.584-3.083a3.083 3.083 0 1 0 0 6.167 3.083 3.083 0 0 0 0-6.167Zm0 1.333a1.75 1.75 0 1 0 0 3.5 1.75 1.75 0 0 0 0-3.5Zm-2.25 1.75a2.25 2.25 0 1 1 4.5 0 2.25 2.25 0 0 1-4.5 0ZM5.333 12.833A3.333 3.333 0 0 1 8.667 9.5h4A3.333 3.333 0 0 1 16 12.833v1.334a.667.667 0 0 1-.667.666H.667A.667.667 0 0 1 0 14.167v-1.334A3.333 3.333 0 0 1 3.333 9.5H4a.667.667 0 1 1 0 1.333h-.667a2 2 0 0 0-2 2v.667h4v-.667Zm1.334.667h8v-.667a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v.667Z"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M3.333 9.75A3.083 3.083 0 0 0 .25 12.833v1.334c0 .23.187.416.417.416h14.666c.23 0 .417-.186.417-.416v-1.334a3.083 3.083 0 0 0-3.083-3.083h-4a3.083 3.083 0 0 0-3.084 3.083v.917h-4.5v-.917a2.25 2.25 0 0 1 2.25-2.25H4a.417.417 0 1 0 0-.833h-.667ZM-.25 12.833A3.583 3.583 0 0 1 3.333 9.25H4a.917.917 0 1 1 0 1.833h-.667a1.75 1.75 0 0 0-1.75 1.75v.417h3.5v-.417A3.583 3.583 0 0 1 8.667 9.25h4a3.583 3.583 0 0 1 3.583 3.583v1.334c0 .506-.41.916-.917.916H.667a.917.917 0 0 1-.917-.916v-1.334Zm6.667 0a2.25 2.25 0 0 1 2.25-2.25h4a2.25 2.25 0 0 1 2.25 2.25v.917h-8.5v-.917Zm2.25-1.75a1.75 1.75 0 0 0-1.75 1.75v.417h7.5v-.417a1.75 1.75 0 0 0-1.75-1.75h-4Z"
      />
    </g>
    <defs>
      <clipPath id="icon-invite-mask">
        <path fill="currentcolor" transform="translate(0 .5)" d="M0 0h16v16H0z" />
      </clipPath>
    </defs>
  </svg>
</template>
